import { render, staticRenderFns } from "./NeedsList.vue?vue&type=template&id=180268a7&scoped=true&"
import script from "./NeedsList.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180268a7",
  null
  
)

export default component.exports